// Angular Imports
import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { environment } from '@environment'
// This Module Imports
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
// Store Imports
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { reducers, metaReducers } from '@store/reducers'
import { effects } from '@store/effects'
// Thirdparty Imports
import { NgxEchartsModule } from 'ngx-echarts'
// Shared Imports
import { EnvironmentDecoratorComponent } from '@shared/components'
import { MaterialModule } from '@shared/modules'

const sharedComponents = [EnvironmentDecoratorComponent]

const sharedModules = [MaterialModule]

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		// Store (NGRX)
		StoreModule.forRoot(reducers, { metaReducers }),
		EffectsModule.forRoot(effects),
		StoreDevtoolsModule.instrument({
			name: 'RMS Store',
			maxAge: 25,
			logOnly: environment.production,
			autoPause: true,
		}),
		// Echarts
		NgxEchartsModule.forRoot({
			echarts: () => import('echarts'),
		}),
		// Shared
		...sharedComponents,
		...sharedModules,
	],
	providers: [],
	bootstrap: [AppComponent],
})
export class AppModule {}
